import type { QueryClient } from '@tanstack/react-query';

const readingRoots = new Set(['items', 'item', 'snapshots', 'folders', 'tags', 'settings']);
/** removeQueries leaves active observers holding their old success data; reset revokes it immediately. */
export function resetDesktopReadingQueries(client: QueryClient) {
  return client.resetQueries({ predicate: (query) => readingRoots.has(String(query.queryKey[0])) });
}
